import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, className = '', noPadding = false }) => {
  return (
    // DEĞİŞİKLİK: 
    // - rounded-2xl -> rounded-xl (Daha ciddi köşeler)
    // - shadow-lg -> shadow-sm (Daha hafif gölge, modern görünüm)
    // - border-gray-100 -> border-gray-200 (Bir tık daha belirgin kenarlık)
    <div className={`bg-white rounded-2xl shadow-sm border border-gray-200/80 ${className}`}>
      <div className={noPadding ? '' : 'p-6'}>
        {children}
      </div>
    </div>
  );
};